import {Injectable} from '@angular/core';
import {BASE_URL} from './../constants';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable,} from 'rxjs';
import {htmlDocument} from '../../models/htmlDocument.model';
import {Entity} from '../../models/entity.model';

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  URL = BASE_URL + '/text/';
  constructor(private http: HttpClient) { }

  document(docId: string): Observable<htmlDocument> {
    let params = new HttpParams();
    params = params.append('docId', docId);
    return this.http.get<any>(this.URL + 'document/', { params }).pipe(map(res => res));
  }

  documentEntities(docId: string, entities: Entity[]): Observable<any> {
    const params = {
      docId,
      entities
    };
    return this.http.post<any>(this.URL + 'document_entities/', params).pipe(map(res => res));
  }

  delete(docId: string): Observable<any> {
    return this.http.post(this.URL + 'document/' + docId + '/delete/', {});
  }

  download(docId: string): Observable<any> {
    return this.http.get(this.URL + 'document_pdf/?docId=' + docId, { responseType: 'blob' as 'json'});
  }
}
